import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import { AuthService } from 'app/auth/auth.service';
import * as backInter from 'app/auth/auth-data.model';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import Swal from 'sweetalert2';

import { DATOS_API } from 'app/auth/auth.datos';
import * as configuracion from 'app/configuracion/home';
import { HomeService } from "./home.service";
import { logosIniciales } from "app/main/pagina/tools/editor-broker/editor-broker.catalogos";
import * as catalogos from "app/main/login/login.catalogos";
import { lang_resultados } from 'app/idiomas/i18n/resultados/resultados.lang';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations : fuseAnimations
})
export class HomeComponent implements OnInit {

  urlAssets = DATOS_API.urlAssets;
  // configHome: any;
  configHome = configuracion.homeCGO;
  logoCGO5 = true;
  urlSafe: SafeResourceUrl;

  imagenes: any[] = [];
  columnas:any = [[],[],[],[]];

  cincoColumnas: boolean;
  cuatroColumnas: boolean;
  unaColumna: boolean;
  jsonsConfiguracion: any = {};
  contenidoExterno = false;
  urlExterna: SafeResourceUrl;
  infoVideo = {
    enable: false,
    video: '',
    loop: false,
    mute: false
  };
  previaCarga = false;

  dominiosEspeciales = catalogos.dominiosEspeciales;
    flagResults:any[]=[];

  constructor(
    private wizardService: WizardService,
    private authService: AuthService,
    public sanitizer: DomSanitizer,
    private homeService: HomeService,
    private _translateService: TranslateService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
  ){
    lang_resultados.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    this.obtieneInstituto();
    let brokerActual = localStorage.getItem('instituto_id') != undefined ? localStorage.getItem('instituto_id') : this.wizardService.getInstituto();
    if(brokerActual == '0'){
      brokerActual = localStorage.getItem('tmpBroker');
      this.configuracionInicial(brokerActual);
    } else{
      if(brokerActual != localStorage.getItem('tmpBroker')){
        localStorage.setItem('tmpBroker', brokerActual);
        this.homeService.getFlag(parseInt(brokerActual)).subscribe((respuesta:any) => {
          console.log("getFlagLogin:",respuesta);
          if(respuesta.success){
            if(respuesta.flagStatus.flag){
              localStorage.setItem('customConfig',"true");
              this.configuracionInicial(brokerActual);
            }
          }
        });
      } else{
        localStorage.removeItem("tmpBroker");
        this.configuracionInicial(brokerActual);
      }
    }

    // this.detectaBrokerEspecial();
    this._translateService.onLangChange.subscribe(() => { this.cambioIdiomaConfiguracion(this._translateService.currentLang,2); });
  }

  ngOnInit() {
    // this.colocaImagenes();
    this.mensajeResultModal();
  }

  configuracionInicial(brokerActual:string){
    let banderaCustConf: boolean = (localStorage.getItem('customConfig') == "true");
    if(banderaCustConf){
      this.setConfiguracionCustom(parseInt(brokerActual));
    } else{
      this.previaCarga = true;
      this.detectaBrokerEspecial();
      this.colocaImagenes();
      this.colocaLogoInicial();
    }
  }

  colocaLogoInicial(tipoLogo?:number){
    if(this.logoCGO5){
      if(!tipoLogo){
        this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl("assets/logo_CGO.html");
      } else{
        let archivoLogo = logosIniciales.find(item => item.opcion == tipoLogo);
        this.urlSafe= this.sanitizer.bypassSecurityTrustResourceUrl(`assets/logo_${archivoLogo.nombre}.html`);
      }
      setTimeout(() => {
        this.logoCGO5 = false;
      }, this.configHome.tiempoLogoInicial);
    }
  }

  setConfiguracionCustom(brokerActual:number){
    this.urlAssets = '';
    this.homeService.getJsons(brokerActual).subscribe((respuesta:any) => {
      console.log("getJsonsLogin:",respuesta);
      if(respuesta.success){
        respuesta.jsonCGO.forEach(json => {
          if(!this.jsonsConfiguracion[json.lang]){
            this.jsonsConfiguracion[json.lang] = json;
          }
        });
        this.cambioIdiomaConfiguracion(this._translateService.currentLang,1);
      }
    });
  }

  mensajeResultModal(){
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this._translateService.get(rspSi).subscribe((res: string) => { rspSi = res; });
 this.homeService.getMensajeResultModal().subscribe((respuesta:any) => {
      console.log("getMensajeResultModal:",respuesta);
      if (respuesta.success==true) {
        this.flagResults=respuesta.flagResults;
        if (this.flagResults[0].flag==true) {
          console.log('idioma nativos ',this._translateService.currentLang);
          this.flagResults[0].modal.forEach(textModal => {
          if (textModal.clave==this._translateService.currentLang) {
            let text=textModal.text
            Swal.fire({
              icon: 'warning',
              title: text,

              confirmButtonText: rspSi,
            });
          }

          });
        }
      }

    });
  }

  cambioIdiomaConfiguracion(idioma:string, via:number){
    console.log("cambioConfIdioma, via:",via);
    let referenciaJson = this.jsonsConfiguracion[idioma].home;
    if(referenciaJson != undefined){
      ///configuracion de otros assets
      this.configHome.logoBranding = referenciaJson.generics.branding.image;
      this.configHome.numeroImagenes = referenciaJson.backgrounds.length;
      this.configHome.filtroGris = referenciaJson.generics.grayFilter;
      this.configHome.tiempoLogoInicial = referenciaJson.generics.startingLogo.time;
      this.contenidoExterno = referenciaJson.generics.externalContent.enable;
      this.urlExterna = this.sanitizer.bypassSecurityTrustResourceUrl(referenciaJson.generics.externalContent.url);
      this.infoVideo = referenciaJson.generics.videoBackground;
      this.colocaImagenes(true);
      if(!this.previaCarga){
        this.logoCGO5 = referenciaJson.generics.startingLogo.show;
        this.previaCarga = true;
        this.colocaLogoInicial(referenciaJson.generics.startingLogo.type);
      }

      if (referenciaJson.loaderGif.image!="") {
        localStorage.setItem('urlGifBroker',referenciaJson.loaderGif.image);
      }else{
        localStorage.setItem('urlGifBroker','https://app04.culturalgo.com/assetsCGO5/platform/img/loading.gif');
      }
    }
  }

  detectaBrokerEspecial(){
    if(localStorage.getItem('tipoBroker')){
      switch (localStorage.getItem('tipoBroker')) {
        case '12345': this.configHome = configuracion.homeIZZI; this.cincoColumnas = true; this.columnas.push([]); break;
        case 'wqKgj6X': this.configHome = configuracion.homeCGO; this.cincoColumnas = true; this.columnas.push([]); break;
      }
    }
    else{
      let dominioEspecial = this.detectaDominioEspecial();
      if(!dominioEspecial){
        this.configHome = configuracion.homeCGO;
        this.columnas = [[],[],[],[]];
        this.cincoColumnas = false;
      }
    }
  }

  detectaDominioEspecial(){
    let [dominio] = (window.location.href).split('#');
    let dominioEncontrado: any;
    let BreakException = {};
    try {
      this.dominiosEspeciales.forEach(domEsp => {
        if(dominio.includes(domEsp.dominio)){
          dominioEncontrado = domEsp;
          throw BreakException;
        }
      });
    } catch (e) {
      if (e !== BreakException) throw e;
    };
    if(dominioEncontrado){
      console.log("dominio coincidente:",dominioEncontrado);
      // this.form.controls['colorTheme'].setValue(dominioEncontrado.tema);
      this.configHome = configuracion[dominioEncontrado.config.home];
    } else{
      console.log("no se encontro dominio especial, actual:",dominio);
    }
    return dominioEncontrado;
  }

  colocaImagenes(custom?:boolean){
    // this.imagenes.push(this.urlAssets + this.configHome.logoBranding);   //la primera imagen es la del logo brand
    let referenciaJson: any;
    // this.columnas = [[],[],[],[]];
    if(custom){
      referenciaJson = this.jsonsConfiguracion[this._translateService.currentLang];
      console.log("referenciaJson:",referenciaJson);
      let numeroColumnas = referenciaJson.home.generics.bgGridColumns;
      this.columnas = [];
      for (let idxCol = 0; idxCol < numeroColumnas; idxCol++) {
        this.columnas.push([]);
      }
    }
    let iterColumna = 0;
    for (let i = 0; i <= this.configHome.numeroImagenes; i++) {
      // this.imagenes.push(
      let branding = false;
      let ruta: string;
      if(custom){
        if(referenciaJson.home.generics.branding.show){
          if(i == 0){
            ruta = this.configHome.logoBranding;
            branding = true;
          }
          else{
            ruta = referenciaJson.home.backgrounds[i-1].image,
            branding = false;
          }
        } else{
          if(i < this.configHome.numeroImagenes){
            console.log("i:",i, "numImg:",this.configHome.numeroImagenes);

            ruta = referenciaJson.home.backgrounds[i].image,
            branding = false;
          }
        }

      } else{
        if(i == 0){
          ruta = this.urlAssets + this.configHome.logoBranding;
          branding = true;
        }
        else{
          ruta = this.urlAssets + this.configHome.rutaImagenes + i + ".jpg",
          branding = false;
        }

      }
      this.columnas[iterColumna].push(
        {
          ruta,
          delay: (200 + (50*i)).toString() + "ms",
          branding
        }
      );
      iterColumna++;
      if(custom){
        let numeroColumnas = referenciaJson.home.generics.bgGridColumns;
        if(numeroColumnas == '5'){
          this.cincoColumnas = true;
        } else if(numeroColumnas == '4'){
          this.cuatroColumnas = true;
        } else if(numeroColumnas == '1'){
          this.unaColumna = true;
        }
        if(iterColumna > (numeroColumnas - 1)){
          iterColumna = 0;
        }
      } else{
        if(this.cincoColumnas){
          if(iterColumna > 4){
            iterColumna = 0;
          }
        }
        else{
          if(iterColumna > 3){
            iterColumna = 0;
          }
        }
      }
    }
    console.log('unaColumna',this.unaColumna);
    console.log('cincoColumnas',this.cincoColumnas);
    console.log('cuatroColumnas',this.cuatroColumnas);

  }

  obtieneInstituto(){
    // let institutoAct = this.wizardService.getInstituto();
    let institutoAct = this.authService.getInstituto();
    localStorage.setItem("institutoValidacionEtiquetas",institutoAct);
    // this.producto();
  }
  // urlImg:string="";
  // producto(){
  //   console.log("Productos brothar");
  //   let infoUsuario = this.authService.getInfoUsuario();
  //   if(infoUsuario.level == 1){
  //     this.wizardService.getProductos().subscribe((data:backInter.infoProductos)=>{
  //       console.log("Porductos");
  //       console.log(data);
  //
  //       if(data.productosNorma35.length > 0 && data.productosCertificar.length==0 && data.productosMedir.length == 0 && data.productosPulseCheck.length ==0 && data.productosFocusArea.length ==0 && data.productosCultureAuditTR.length ==0 && data.productosMedir2.length== 0 ){
  //         this.urlImg="./assets/images/sliders/Xpresate.jpeg";
  //       }else{
  //         this.urlImg="./assets/images/sliders/1.jpg"
  //       }
  //     });
  //   }
  // }

}
